import { fontFamily } from "../tokens/typography";
export const header1Styles = {
    fontSize: '5.4rem',
    lineHeight: 1.1,
    fontFamily: fontFamily.roboto,
};
export const smallHeader1Styles = {
    fontSize: '3.6rem',
    lineHeight: 1.2,
    fontFamily: fontFamily.roboto,
};
export const header2Styles = {
    fontSize: '3.8rem',
    lineHeight: 1.2,
    fontFamily: fontFamily.roboto,
};
export const smallHeader2Styles = {
    fontSize: '2.6rem',
    lineHeight: 1.3,
    fontFamily: fontFamily.roboto,
};
export const header3Styles = {
    fontSize: '3rem',
    lineHeight: 1.2,
    fontFamily: fontFamily.roboto,
};
export const smallHeader3Styles = {
    fontSize: '2.2rem',
    lineHeight: 1.3,
    fontFamily: fontFamily.roboto,
};
export const header4Styles = {
    fontSize: '2.2rem',
    lineHeight: 1.3,
    fontFamily: fontFamily.roboto,
};
export const smallHeader4Styles = {
    fontSize: '1.8rem',
    lineHeight: 1.4,
    fontFamily: fontFamily.roboto,
};
export const header5Styles = {
    fontSize: '2rem',
    lineHeight: 1.3,
    fontFamily: fontFamily.roboto,
};
export const smallHeader5Styles = {
    fontSize: '1.8rem',
    lineHeight: 1.4,
    fontFamily: fontFamily.roboto,
};
export const body1Styles = {
    fontSize: '1.8rem',
    lineHeight: 1.5,
    fontFamily: fontFamily.roboto,
};
export const smallBody1Styles = {
    fontSize: '1.6rem',
    lineHeight: 1.5,
    fontFamily: fontFamily.roboto,
};
export const body2Styles = {
    fontSize: '1.6rem',
    lineHeight: 1.5,
    fontFamily: fontFamily.roboto,
};
export const smallBody2Styles = {
    fontSize: '1.4rem',
    lineHeight: 1.5,
    fontFamily: fontFamily.roboto,
};
export const body3Styles = {
    fontSize: '1.4rem',
    lineHeight: 1.5,
    fontFamily: fontFamily.roboto,
};
